import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-form-mesa-ayuda',
  templateUrl: './form-mesa-ayuda.component.html',
  styleUrl: './form-mesa-ayuda.component.scss'
})
export class FormMesaAyudaComponent implements OnInit, AfterViewInit {
  url_mesa_ayuda: SafeResourceUrl;
  url_form = 'https://forms.office.com/r/qvbiYWHmhb'

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const url = this.url_form + '&embed=true';
    this.url_mesa_ayuda = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngAfterViewInit(): void {
    this.isMobileDevice() ? window.open(this.url_form, '_blank') : null;
  }

  isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      .test(navigator.userAgent);
  }
}
